import React from 'react';
import Icon from 'components/AppIcon';

const Stepper = ({ current, steps }) => {
  const iconMap = {
    Personal: "User",
    "Next of Kin": "Users",
    Documents: "FileText",
    Photos: "Image",
    Review: "CheckCircle",
  };
  return (
    <div className="flex items-center gap-3 mb-6">
      {steps.map((s, idx) => {
        const active = idx === current;
        const done = idx < current;
        return (
          <div key={s} className="flex items-center">
            <div
              className={`w-9 h-9 rounded-full flex items-center justify-center shadow-sm border ${
                active
                  ? "bg-primary text-white border-primary"
                  : done
                  ? "bg-green-600 text-white border-green-600"
                  : "bg-secondary-100 text-secondary-700 border-secondary-200"
              }`}
            >
              <Icon name={iconMap[s] || "Dot"} size={16} />
            </div>
            <span
              className={`ml-2 mr-4 text-sm ${
                active ? "text-text-primary font-medium" : "text-text-secondary"
              }`}
            >
              {idx + 1}. {s}
            </span>
            {idx < steps.length - 1 && (
              <div className="w-8 h-0.5 bg-secondary-200" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
